import {getFeaturedContestBySlug, getParticipants, loginWithMagicToken, trackEvent} from '@/api/participant.js';
import {getQuizForContest} from '@/api/quiz.js';
import {syncUserContestStatus} from './contestService.js';
import {mapBackendToFrontend} from '@/utils/mappers.js';
import {CONTEST_ACTIONS} from '@/hooks/contest/contestActions.js';
import {PARTICIPANT_STATUS} from '@/hooks/contest/contestStatus.js';
import {TRACK_EVENT} from "@/utils/constants.js";
import {APP_STEPS} from "@/hooks/contest/contestSteps.js";
import i18n from "i18next";

export const initializeContest = async (dispatch, contestSlug, contestId, source, magicToken, onNotFound) => {
    if (magicToken) {
        try {
            await loginWithMagicToken(magicToken);
            console.log("🔐 Magic login success");
        } catch (e) {
            console.warn("⚠️ Magic login failed or expired:", e);
        }
    }

    const contest = await getFeaturedContestBySlug(contestSlug, contestId);
    if (!contest || !contest.fixture || Object.keys(contest).length === 0) {

        if (onNotFound) {
            onNotFound();
            return;
        }

        dispatch({type: CONTEST_ACTIONS.SET_STEP, payload: APP_STEPS.NO_CONTEST});
        dispatch({type: CONTEST_ACTIONS.SET_LOADING, payload: false});
        dispatch({
            type: CONTEST_ACTIONS.INIT_SUCCESS,
            payload: {contest: null, matchScore: {team1: 0, team2: 0}}
        });
        return;
    }

    trackEvent(contest.id, source, TRACK_EVENT.VIEW);

    const locale = contest?.locale;

    if (locale) {
        i18n.changeLanguage(locale);
    }

    dispatch({
        type: CONTEST_ACTIONS.INIT_SUCCESS,
        payload: {
            contest,
            matchScore: {team1: contest?.fixture?.homeTeam?.score || 0, team2: contest?.fixture?.awayTeam?.score || 0}
        }
    });

    const {status, step, isAnonymous} = await syncUserContestStatus(contest.id, contest.status, dispatch);

    if (isAnonymous && step === APP_STEPS.MISSED) {
        try {
            const quiz = await getQuizForContest(contest.id);
            if (quiz) dispatch({type: CONTEST_ACTIONS.SET_STEP, payload: APP_STEPS.QUIZ});
        } catch {
            // pas de quiz disponible, on reste sur MISSED
        }
    }

    const shouldFetchLeaderboard = [
        PARTICIPANT_STATUS.JOINED_PENDING,
        PARTICIPANT_STATUS.JOINED_PENDING_QUIZ,
    ].includes(status);

    if (shouldFetchLeaderboard) {
        const rawParticipants = await getParticipants(contest.id);
        const formatted = mapBackendToFrontend(rawParticipants);

        dispatch({
            type: CONTEST_ACTIONS.UPDATE_LEADERBOARD,
            payload: {list: formatted}
        });
    }
};